import { render, staticRenderFns } from "./new-paper-dialog.vue?vue&type=template&id=51ada2a6&scoped=true"
import script from "./new-paper-dialog.vue?vue&type=script&lang=js"
export * from "./new-paper-dialog.vue?vue&type=script&lang=js"
import style0 from "./new-paper-dialog.vue?vue&type=style&index=0&id=51ada2a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ada2a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ada2a6')) {
      api.createRecord('51ada2a6', component.options)
    } else {
      api.reload('51ada2a6', component.options)
    }
    module.hot.accept("./new-paper-dialog.vue?vue&type=template&id=51ada2a6&scoped=true", function () {
      api.rerender('51ada2a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/new-paper-dialog.vue"
export default component.exports